import selectTotalFields from './select-total-fields';
import {createSelector} from '@reduxjs/toolkit';

export default (coe: number) =>
  createSelector([selectTotalFields], totals => {
    return Number(totals?.reseller_price) * coe;
  });
